import { errorMessage } from "helpers/utils";
import { call, put, select, takeEvery } from "redux-saga/effects";
import UserService from "services/UserService";
import {
  CREATE_ACCOUNT_BANK,
  CREATE_USER_INVOICE,
  DELETE_USER_INVOICE,
  EDIT_USER_INVOICE,
  GET_ALL_ACCOUNT_BANK,
  GET_ALL_USER_INVOICE,
  GET_DETAIL_USER_INVOICE,
  GET_LIST_USER_INVOICE,
} from "./actionTypes";
import {
  createAccountBankFail,
  createAccountBankSuccess,
  createUserInvoiceFail,
  createUserInvoiceSuccess,
  deleteUserInvoiceFail,
  deleteUserInvoiceSuccess,
  editUserInvoiceFail,
  editUserInvoiceSuccess,
  getAllAccountBankFail,
  getAllAccountBankSuccess,
  getAllUserInvoiceFail,
  getAllUserInvoiceSuccess,
  getDetailUserInvoiceFail,
  getDetailUserInvoiceSuccess,
  getListUserInvoiceFail,
  getListUserInvoiceSuccess,
} from "./actions";

function* fetchGetUserInvoice({ params }) {
  try {
    const perPage = params.sizePerPage;
    const page = params.page;
    const columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;
    // Call api
    const response = yield call(
      UserService.listUser,
      page,
      perPage,
      columnFilter,
      keywords,
      sort
    );
    const totalCount = response._meta.totalCount;
    yield put(getListUserInvoiceSuccess(response.items, totalCount));
  } catch (error) {
    yield put(getListUserInvoiceFail(errorMessage(error)));
  }
}

function* fetchGetDetailUserInvoice({ id }) {
  try {
    let response = yield call(UserService.detailUser, id);
    console.log(
      "🚀 ~ function*fetchGetDetailUserInvoice ~ response:",
      response
    );
    const responseUserBu = yield call(UserService.listUserBu, response?.code);
    console.log(
      "🚀 ~ function*fetchGetDetailUserInvoice ~ responseUserBu:",
      responseUserBu
    );
    response = {
      ...response,
      ...responseUserBu,
    };
    // console.log("response", response);
    yield put(getDetailUserInvoiceSuccess(response));
  } catch (error) {
    yield put(getDetailUserInvoiceFail(errorMessage(error)));
  }
}

function* fetchCreateUserInvoice({ data }) {
  try {
    const response = yield call(UserService.createUser, data);
    yield put(createUserInvoiceSuccess(response));
  } catch (error) {
    yield put(createUserInvoiceFail(errorMessage(error)));
  }
}

function* fetchCreateAccountBank({ data }) {
  try {
    let { buStoreHeader } = yield select(state => state.Dashboard);
    const response = yield call(
      UserService.createAccountBank,
      data,
      buStoreHeader
    );
    yield put(createAccountBankSuccess(response));
  } catch (error) {
    yield put(createAccountBankFail(errorMessage(error)));
  }
}

function* fetchEditUserInvoice({ data, id }) {
  try {
    // const response = yield call(UserService.editUser, data, id);
    const responseUpdateBu = yield call(UserService.updateBuUser, data);
    console.log(
      "🚀 ~ function*fetchEditUserInvoice ~ responseUpdateBu:",
      responseUpdateBu
    );
    yield put(editUserInvoiceSuccess(responseUpdateBu));
  } catch (error) {
    yield put(editUserInvoiceFail(errorMessage(error)));
  }
}

function* fetchDeleteUserInvoice({ id }) {
  try {
    const response = yield call(UserService.deleteUser, id);
    // Wait XML generate
    yield put(deleteUserInvoiceSuccess(response));
  } catch (error) {
    yield put(deleteUserInvoiceFail(errorMessage(error)));
  }
}

function* fetchGetAllUser({ type_id }) {
  try {
    const response = yield call(UserService.listAllUser, type_id);
    const list = response.items.map(item => {
      return {
        ...item,
        value: item.ma,
        label: item.ma,
      };
    });
    yield put(getAllUserInvoiceSuccess(list));
  } catch (error) {
    yield put(getAllUserInvoiceFail(errorMessage(error)));
  }
}

function* fetchGetAllAccountBank({}) {
  try {
    let { buStoreHeader } = yield select(state => state.Dashboard);
    const response = yield call(UserService.listAllAccountBank, buStoreHeader);
    const list = response.items.map(item => {
      return {
        ...item,
        value: item.account_number,
        label: item.account_number + " - " + item.bank_name,
      };
    });
    yield put(getAllAccountBankSuccess(list));
  } catch (error) {
    yield put(getAllAccountBankFail(errorMessage(error)));
  }
}

function* userInvoiceSaga() {
  yield takeEvery(GET_LIST_USER_INVOICE, fetchGetUserInvoice);
  yield takeEvery(GET_DETAIL_USER_INVOICE, fetchGetDetailUserInvoice);
  yield takeEvery(CREATE_USER_INVOICE, fetchCreateUserInvoice);
  yield takeEvery(EDIT_USER_INVOICE, fetchEditUserInvoice);
  yield takeEvery(DELETE_USER_INVOICE, fetchDeleteUserInvoice);
  yield takeEvery(CREATE_ACCOUNT_BANK, fetchCreateAccountBank);

  yield takeEvery(GET_ALL_USER_INVOICE, fetchGetAllUser);
  yield takeEvery(GET_ALL_ACCOUNT_BANK, fetchGetAllAccountBank);
}

export default userInvoiceSaga;
